import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
    background-color: #FAFAFA;
    padding: 4rem 0 2rem 0;
    border-top: 1px solid #E5E7EB;
`;

export const FooterContent = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;

    @media (min-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
        padding: 0 1.5rem;
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
        padding: 0 2rem;
    }
`;

export const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const FooterLogo = styled.h3`
    font-family: 'CocomatProBold', sans-serif;
    font-size: 1.5rem;
    color: #111827;
    margin: 0;
    padding: 0;
`;

export const SocialLinks = styled.div`
    display: flex;
    gap: 0.75rem;
    margin-top: 0.5rem;
`;

export const SocialIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #F3F4F6;
    color: #111827;
    transition: all 200ms ease;
    text-decoration: none;

    &:hover {
        background-color: #E5E7EB;
        transform: translateY(-2px);
    }
`;

export const FooterTitle = styled.h4`
    font-size: 0.875rem;
    font-weight: 700;
    color: #111827;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const FooterLink = styled(Link)`
    font-size: 0.875rem;
    color: #6B7280;
    text-decoration: none;
    transition: color 200ms ease;

    &:hover {
        color: #111827;
    }
`;

export const AppStoreButton = styled.a`
    display: inline-block;
    padding: 0.75rem 1rem;
    background-color: #111827;
    color: white;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 8px;
    text-decoration: none;
    text-align: center;
    transition: all 200ms ease;
    cursor: pointer;

    &:hover {
        background-color: #1F2937;
        transform: translateY(-2px);
    }
`;

export const PlayStoreButton = styled.a`
    display: inline-block;
    padding: 0.75rem 1rem;
    background-color: #111827;
    color: white;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 8px;
    text-decoration: none;
    text-align: center;
    transition: all 200ms ease;
    cursor: pointer;

    &:hover {
        background-color: #1F2937;
        transform: translateY(-2px);
    }
`;

export const FooterBottom = styled.div`
    max-width: 1280px;
    margin: 3rem auto 0 auto;
    padding: 2rem 1rem 0 1rem;
    border-top: 1px solid #E5E7EB;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;

    @media (min-width: 640px) {
        flex-direction: row;
        justify-content: space-between;
        padding: 2rem 1.5rem 0 1.5rem;
    }

    @media (min-width: 1024px) {
        padding: 2rem 2rem 0 2rem;
    }
`;

export const Copyright = styled.p`
    font-size: 0.875rem;
    color: #6B7280;
    margin: 0;
`;

export const VersionInfo = styled.p`
    font-size: 0.75rem;
    color: #9CA3AF;
    opacity: 0.7;
    margin: 0;
    font-family: monospace;
    white-space: nowrap;
`;
